/* src/app/subscription-packages/package/feature-dialog/feature-dialog.component.scss */
.label {
  text-align: center;
}
.description {
  text-align: center;
  white-space: pre-wrap;
}
/*# sourceMappingURL=feature-dialog.component.css.map */
